import { db, SelectionState } from 'Compass/profile-lab/services/db';

interface SelectionSets {
  selectedSet: Set<number>;
  growSet: Set<number>;
  selectionState: SelectionState;
}

export const getSelectionSets = async (): Promise<SelectionSets> => {
  const selectionState = await db.getSelectionState();
  return {
    selectedSet: new Set(selectionState.selected),
    growSet: new Set(selectionState.grow),
    selectionState
  };
};
